import $api from "@/core/services/ApiService";
import { AxiosResponse } from "axios";
import {
  PortalService,
  PortalServiceEnum,
} from "@/core/services/api/interfaces/dict/PortalService";
import {
  BankAccountPortalAutoTransfer,
  PortalServiceCompanySignUp,
  PortalServiceEmployeeSignUp,
} from "@/core/services/api/interfaces/manager/BankAccount";

class PortalServiceEndpoint {
  public signInPortalService(
    portalService: PortalService | PortalServiceEnum
  ): Promise<AxiosResponse> {
    const slug =
      typeof portalService === "string" ? portalService : portalService.value;

    return $api.get(`manager/portals/${slug}/sign-in`);
  }

  public configureAutoTransfer(
    request: BankAccountPortalAutoTransfer
  ): Promise<AxiosResponse> {
    return $api.post(`manager/portals/auto-transfer`, request);
  }

  public removeAutoTransfer(account_id: number): Promise<AxiosResponse> {
    return $api.delete(`manager/portals/auto-transfer/${account_id}`);
  }

  public getRemoteAccounts(
    portalService: PortalService | PortalServiceEnum
  ): Promise<AxiosResponse> {
    const slug =
      typeof portalService === "string" ? portalService : portalService.value;

    return $api.get(`manager/portals/${slug}/remote-accounts`);
  }

  public signUpCompany(
    portalService: PortalService | PortalServiceEnum,
    questionnaire: PortalServiceCompanySignUp
  ): Promise<AxiosResponse> {
    const slug =
      typeof portalService === "string" ? portalService : portalService.value;

    return $api.post(`manager/portals/${slug}/sign-up/company`, questionnaire);
  }

  public signUpEmployee(
    portalService: PortalService | PortalServiceEnum,
    questionnaire: PortalServiceEmployeeSignUp
  ): Promise<AxiosResponse> {
    const slug =
      typeof portalService === "string" ? portalService : portalService.value;

    return $api.post(`manager/portals/${slug}/sign-up/employee`, questionnaire);
  }
}

export default PortalServiceEndpoint;
